import SparkMD5 from "spark-md5"
import CryptoJS from 'crypto-js'
export default{
    /**
     * 加载图片
     * @param  string   url     图片链接
     * @param  function success 加载成功回调
     * @param  function error   加载失败回调
     */
    loadImage: function(url, success, error) {
        let img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.crossOrigin = 'anonymous';
        img.src = url;
        img.onload = function() {
            if (success) {
                success(img)
            }
        }
        img.onerror = function() {
            if (error) {
                error(img)
            }
        }
    },
    /**
     * 将base64转化为blob
     * @param  base64  urlData 
     * @return bolb         
     */
    convertBase64UrlToBlob: function (urlData){
        var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type:mime});
    },
    /**
     * 将图片转化为base64
     * @param  img      imgObj        图像对象
     * @return base64   string     转化的base64码
     */
	getBase64Image: function (img) {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height);
        var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
        var dataURL = canvas.toDataURL('image/' + ext);
        return dataURL;
    },
    /**
     * 文件md5加密
     * @param  file       Blob       文件blob
     * @param  callback   function   回调函数

     */
    getFileMd5: function (file, callback) {
        var timestamp = new Date().getTime();
        var data_md5;
        var file = file;
        var tmp_md5 = null;

        var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
            chunkSize = 8097152,
            chunks = Math.ceil(file.size / chunkSize),
            currentChunk = 0,
            spark = new SparkMD5.ArrayBuffer(),
            fileReader = new FileReader();
        fileReader.onload = function (e) {
            spark.append(e.target.result);
            currentChunk++;
            if (currentChunk < chunks) {
                loadNext();
            } else {
                callback(spark.end())
            }
        };

        fileReader.onerror = function() {
            clearTimeout(timeOut)
                showMessageBox('error', UPLOAD_ERROR)
        };

        function loadNext() {
                var start = currentChunk * chunkSize,
                        end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
                fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
        }
        loadNext();
    },
    /*
    * AES加密
     */
    encrypt: function (str) {
        var key  = CryptoJS.enc.Latin1.parse('KgACJju0JScxBvlP');
        var iv   = CryptoJS.enc.Latin1.parse('wmozBgboU9HRzWG6');
        var encrypted = CryptoJS.AES.encrypt(str, key,{
                iv:iv,
                mode:CryptoJS.mode.CBC,
        });
        return encrypted.toString();
    },
    // 判断域名调用接口
    urlPost:function(str){
        var accountHref,imagePost,post_url;
        if(location.hostname==hostUrl || 
        location.hostname==hostUrlFr || 
        location.hostname==hostUrlDe || 
        location.hostname==hostUrlJp || 
        location.hostname==hostUrlZhcn || 
        location.hostname==hostUrlZhtw || 
        location.hostname==hostUrlCs || 
        location.hostname==hostUrlDa || 
        location.hostname==hostUrlNl || 
        location.hostname==hostUrlFi || 
        location.hostname==hostUrlEl || 
        location.hostname==hostUrlIt || 
        location.hostname==hostUrlNo || 
        location.hostname==hostUrlPl || 
        location.hostname==hostUrlPt || 
        location.hostname==hostUrlRu || 
        location.hostname==hostUrlEs || 
        location.hostname==hostUrlBr ||
        location.hostname==hostUrlSv || 
        location.hostname==hostUrlHu || 
        location.hostname==hostUrlTr
        ){
             imagePost=imagePost_pro;
             post_url=postUrl;
             accountHref=accountHref_pro;
        }else{
             imagePost=imagePostDev
             post_url=post_url_dev;
             accountHref=accountHrefDev;
        }
        if(str=='image'){
            return imagePost
        }
        if(str=='account'){
            return post_url
        }
        if(str=='accountHref'){
            return accountHref
        }
    },
    setCookie(name,value,iDay){      //name相当于键，value相当于值，iDay为要设置的过期时间（天）
        var oDate = new Date();
        oDate.setDate(oDate.getDate() + iDay);
        document.cookie = name + '=' + value + ';path=/;domain=.aiseesoft.com;expires=' + oDate.toUTCString();
        // document.cookie = name + '=' + value + ';path=/;expires=' + oDate;
    },
    // 生成不重复唯一id
    getDocId(len){
        var timestamp = Date.parse(new Date());
        var s = []
        var hexDigits = "0123456789abcdef"
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        if(len){
            var uuid = s.join("").slice(0,len)
            return uuid
        }
        s[14] = timestamp
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
        s[8] = s[13] = s[18] = s[23] = "-"
    
        var uuid = s.join("")
        return uuid
    },
    
    //获取cookie
    getCookie(name) {
        var prefix = name + "="
        var start = document.cookie.indexOf(prefix)
     
        if (start == -1) {
            return null;
        }
     
        var end = document.cookie.indexOf(";", start + prefix.length)
        if (end == -1) {
            end = document.cookie.length;
        }
     
        var value = document.cookie.substring(start + prefix.length, end)
        return unescape(value);
    },
    getLang(){
        var url = window.location.host;
        var lang = getCookie('lang');
        try {
            var urlArr = url.split(".");
            if(urlArr[2]=='de' || urlArr[2]=='fr' || urlArr[2]=='jp'){
                lang=urlArr[2];
            }
        }catch(e){

        }
        return lang;
    },
    isDomain(){
        var url = window.location.host;
        try {
            var urlArr = url.split(".");
            if(urlArr[2]=='de' || urlArr[2]=='fr' || urlArr[2]=='jp'){
                return true;
            }
        }catch(e){

        }
        return false;
    },

    // 防抖函数
    // debounce(fn, wait) {
    //     let timer = null;
    //     return function (...args) {
    //       if (timer) {
    //         clearTimeout(timer)
    //         timer = null
    //       }
    //       timer = setTimeout(function () {
    //         fn.apply(this, args)
    //       }, wait)
    //     }
    // },
    // immediate 是否开始立即执行
    debounce(func, delay = 3000, immediate = true) {
        let timer = null
        return function() {
            if (timer) {
                clearTimeout(timer)
            }
            if (immediate && !timer) {
                func.apply(this, arguments)
            }
            timer = setTimeout(() => {
            func.apply(this, arguments)
            }, delay)
        }
    },
    throttle(fn, time) {
        let timer = null
        time = time || 1000
        return function(...args) {
          if (timer) {
            return
          }
          const _this = this
          timer = setTimeout(() => {
            timer = null
          }, time)
          fn.apply(_this, args)
        }
      }
}